var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.759,
    height: 37.387,
    viewBox: "0 0 28.759 37.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-lock",
    "data-name": "Icon ionic-ios-lock",
    d: "M31.914,16.317H29.757v-4.2A8.628,8.628,0,1,0,12.5,12v4.314H10.345A3.605,3.605,0,0,0,6.75,19.911V37.167a3.605,3.605,0,0,0,3.595,3.595H31.914a3.605,3.605,0,0,0,3.595-3.595V19.911A3.605,3.605,0,0,0,31.914,16.317ZM22.388,27.533v6.183a1.289,1.289,0,0,1-1.2,1.294,1.26,1.26,0,0,1-1.321-1.258V27.533a2.876,2.876,0,1,1,2.516,0Zm4.853-11.216H15.018V12a6.111,6.111,0,0,1,12.222,0Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#74ad85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4b32dc7a.svg";
export { ForwardRef as ReactComponent };